<template>
  <div>
    <!-- split order -->
    <div class="modal show_modal" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-lg-custom modal-dialog-centered">
        <div class="modal-content">
           <div class="modal-header">
            <div class="container">
              <button   type="button" style="position: absolute;" @click="Close()"  class="btn btn-small text-white" >
                <v-icon class="text-white">mdi-arrow-left</v-icon> {{ $t("Back") }}
              </button> 
              <div class="text-center">
                 <h6>{{ $t("Split Bill") }}</h6> 
              </div>
             </div>
          </div>


          <div class="modal-body" style="height: auto">
            
             <div class="container"> 
                <div class="row"> 
                  <template v-if="tab== 1">
                    <div class="col-lg-5"> 
                      <div class="card mt-3">
                        <div class="split_icon">
                          <img
                            src="@/assets/images/split_icon.svg"
                            width="20px"
                            alt=""
                          />
                        </div>
                        <VuePerfectScrollbar class="scroll-item-split">
                          <v-simple-table>
                            <template v-slot:default>
                              <thead>
                                <tr>
                                  <th class="text-left">{{ $t("Description") }}</th>
                                  <th class="text-left">{{ $t("Quantity") }}</th>
                                </tr>
                              </thead>
                              <tbody>
                                <!--  -->
                                <tr
                                  v-for="sale in invoice_map"
                                  :key="sale.id"
                                  v-bind:class="{
                                    selected_split: isSelect(sale) == true,
                                  }"
                                >
                                  <td>
                                    <span class="font-weight-bold">
                                      {{ sale.venueitem_name }}</span
                                    >
                                    <p
                                      v-for="(option, index) in sale.options"
                                      :key="index"
                                    >
                                      {{ option.title }} :
                                      <span
                                        :key="indexOp"
                                        v-for="(
                                          op, indexOp
                                        ) in option.option_optionvalue"
                                        >{{ op.optionvalue_title }}</span
                                      >
                                    </p>
                                    <template v-if="sale.note">
                                      <br />
                                      {{ $t("Note") }} : {{ sale.note }}
                                    </template>
                                  </td>
                                  <td width="40%" style="padding: 10px">
                                    <div style="display: flex">
                                      <base-number-input
                                        v-model="sale.qty"
                                        :max-value="sale.max_qty"
                                      ></base-number-input>

                                      <button
                                        v-if="invoice_map.length > 1 || invoice_map[0].qty > 0"
                                        class="btn btn-primary ml-2"
                                        @click="selectedItem(sale)"
                                      >
                                        {{ $t("Move") }}  
                                      </button>
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </template>
                          </v-simple-table>
                        </VuePerfectScrollbar>
                      </div>
                    </div>
                    <div class="col-lg-5">
                      <!-- <button class="btn btn-brand" @click="showCustomerDialog()">
                        <icon icon="user-plus" class="icon" />
                        <span class="ml-2">{{ customer.name }}</span>
                      </button> -->
                      <div class="card mt-3">
                        <VuePerfectScrollbar class="scroll-item-split">
                          <v-simple-table>
                            <template v-slot:default>
                              <thead>
                                <tr>
                                  <th class="text-left">{{ $t("Description") }}</th>
                                  <th width="10%" class="text-left">
                                    {{ $t("Quantity") }}
                                  </th>
                                  <th width="10%"></th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="sale in selected" :key="sale.id">
                                  <td>
                                    <span class="font-weight-bold">
                                      {{ sale.venueitem_name }}</span
                                    >
                                    <p
                                      v-for="(option, index) in sale.options"
                                      :key="index"
                                    >
                                      {{ option.title }} :
                                      <span
                                        :key="indexOp"
                                        v-for="(
                                          op, indexOp
                                        ) in option.option_optionvalue"
                                        >{{ op.optionvalue_title }}</span
                                      >
                                    </p>
                                    <template v-if="sale.note">
                                      <br />
                                      {{ $t("Note") }} : {{ sale.note }}
                                    </template>
                                  </td>
                                  <td>{{ sale.qty }}</td>
                                  <td width="10%" style="padding: 10px">
                                    <button
                                      class="btn btn-primary ml-2"
                                      @click="reverseSelectedItem(sale)"
                                    >
                                      <icon icon="arrow-left" />
                                    </button>
                                  </td>
                                </tr>
                              </tbody>
                            </template>
                          </v-simple-table>
                        </VuePerfectScrollbar>
                      </div>
                    </div>
                  </template>
                  <template v-if="tab== 2">
                        <div class="col-lg-10"> 
                                  <div class="center-flex">
                                     <div class="wrap-cal" > 
                                          <h4> {{ $t("Amount to paid") }} :  {{ invoice.currency_code }}    {{  (invoice.amount_to_be_paid - invoice.amount_paid) | commaNumber  }} </h4>
                                          <br>
                                          
                                          <label for="basic-url"> {{ $t('Person') }}</label>
                                          <div class="input-group mb-3" v-if="input_split_person"> 
                                            <div class="input-group-prepend" v-if="total_person > 1" @click="total_person --">
                                              <span class="input-group-text pl-4 pr-4"> - </span>
                                            </div>
                                            <input type="number" v-model ="total_person" class="form-control" >
                                            <div class="input-group-append" @click="total_person ++">  
                                              <span class="input-group-text pl-4 pr-4">+</span>
                                            </div>
                                          </div>


                                          <div class="input-group mb-3" v-for="index in Number(total_person)" :key="index">
                                            <input type="text" :value="((invoice.amount_to_be_paid - invoice.amount_paid)/total_person) | commaNumber" class="form-control" disabled>
                                            <div class="input-group-append"> 
                                                <span class="input-group-text">{{ invoice.currency_code }}  </span> 
                                              
                                              <button @click="splitPerson(index)" v-if="!index_charge.includes(index)" class="btn btn-outline-primary" type="button"> {{ $t('Charge') }} </button>
                                              <button v-else disabled class="btn btn-outline-secondary">{{ $t('Paid') }}</button>
                                           
                                           </div>
                                          </div>


                                     </div>
                                  </div> 
                        </div>

                  </template>
                  <div class="col-lg-2"> 
                    <button class="btn btn-block btn-close" v-bind:class="{ 'has-split-btn' : tab == 1}" @click="tab= 1">
                      {{ $t("Split Menu Item") }} 
                    </button>
                     <button class="btn btn-block btn-close" v-bind:class="{ 'has-split-btn' : tab == 2}"  @click="tab=2">
                      {{ $t("Split by Persons") }}
                    </button>
                     <button class="btn btn-block btn-close" @click="submit()" v-if="tab == 1">
                      {{ $t("Split order") }}
                    </button> 
                  </div>
                </div>
             </div>
          </div>
        </div>
      </div>
    </div>


    <!-- customer -->
    <div class="modal show_modal"  v-if="modal_customer" tabindex="-1"  role="dialog">
        <div class="modal-dialog modal-lg modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-body modal-body-custom">
              <h4 class="mb-5">{{ $t("Select") }} {{ $t("Customer") }}</h4>
              <form v-on:submit.prevent="getCustomer">
                <div class="input-group mb-3">
                  <input
                    type="text"
                    class="form-control"
                    v-model="model_customer.search"
                    @keyup="getCustomer()"
                    :placeholder="
                      $t('Enter') +
                      ' ' +
                      $t('name') +
                      ' ' +
                      $t('phone') +
                      ', ' +
                      $t('email')
                    "
                  />
                  <div class="input-group-append pointer" @click="getCustomer">
                    <span class="input-group-text">
                      <icon icon="search" />
                    </span>
                  </div>
                  <button
                    class="btn btn-default ml-3 mb-3"
                    @click="modal_create_customer = true"
                  >
                    {{ $t("Create Customer") }}
                  </button>
                </div>
              </form>
              <VuePerfectScrollbar style="height: 56vh">
                <div class="m-2 mr-3">
                  <div
                    class="card w-100 m-1"
                    v-for="(cust, index) in customers"
                    :key="index"
                    :class="{ customer_selected: cust.id === customer.id }"
                    @click="setCustomer(cust)"
                  >
                    <div class="card-body" style="padding: 10px">
                      <h5 class="card-title">
                        {{ cust.name || $t("N/A") }}
                      </h5>
                      <p class="card-text">
                        <span class="mr-2"
                          >{{ $t("Customer ID") }}: {{ cust.id }}</span
                        >

                        <v-icon
                          style="color: lightgrey"
                          v-if="cust.email"
                          class="ml-2"
                          >mdi-email</v-icon
                        >
                        {{ cust.email }}
                        <v-icon
                          style="color: lightgrey"
                          v-if="cust.phone"
                          class="ml-2"
                          >mdi-phone</v-icon
                        >
                        {{ cust.phone }}
                      </p>
                      <p></p>
                    </div>
                  </div>
                </div>
                <loading v-if="loading_customer"></loading>

                <nodata
                  class="text-center"
                  v-if="(customers.length < 1) & !loading_customer"
                ></nodata>
              </VuePerfectScrollbar>
            </div>
            <div class="modal-footer">
              <p-pagination
                v-model="model_customer.page"
                class="pull-center mr-auto"
                :per-page="Number(meta_customers.per_page)"
                :page-count="meta_customers.last_page"
                :total="meta_customers.total"
              />
              <button
                type="button"
                @click="modal_customer = false"
                class="btn btn-close"
                data-dismiss="modal"
              >
                {{ $t("Close") }}
              </button>
            </div>
          </div>
        </div>
    </div>

    <!-- create customer -->
    <div   class="modal show_modal"   v-if="modal_create_customer"   tabindex="-1" role="dialog"  >
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body p-5">
            <base-customer   v-model="customer"     v-on:saved="customerSave" ></base-customer>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              @click="modal_create_customer = false"
              class="btn btn-close"
              data-dismiss="modal"
            >
              {{ $t("Close") }}
            </button>
          </div>
        </div>
      </div>
    </div>


<!-- modal success -->
    <div
        class="modal show_modal" 
        tabindex="-1"
        role="dialog"
        v-if="modal_success"
      >
        <div class="modal-dialog modal-md modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-body text-center" style="height: 130px; display:flex;  align-items: center;
              justify-content: center;">
              <button class="btn btn-primary m-2 p-4" @click="openSale(false)">
                {{ $t('Open old sale')}}
              </button>
              <button class="btn btn-primary m-2 p-4" @click="openSale(true)">
                {{ $t('Open split order')}}
              </button>
            </div> 
          </div>
        </div>
    </div>

     <base-modal-print-view :order="order_print" v-model="modal_invoice_preview" v-if="modal_invoice_preview"> </base-modal-print-view>

  </div>
</template>
<style >
.selected_split td {
  background: #f7fbd5 !important;
}
.split_icon {
  position: absolute;
  right: 0;
  top: 50%;
  margin-right: -28px;
}
.scroll-item-split {
  height: 70vh;
}
</style>

<script>
import Swal from "sweetalert2";
import store from "@/store";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
 
export default {
  name: "BaseSplitSale",
  components: {
    VuePerfectScrollbar,
  },
  props: {
    invoice: {
      type: Object,
      default: {},
    },
  },
  data: () => ({
    modal_invoice_preview: false,
    model_customer: {},
    modal_customer: false,
    modal_create_customer: false,
    modal_success: false,
    tab: 1,
    total_person: 1,
    selected: [],
    invoice_map: [],
    customer: {
      id: 0,
      name: "",
    },
    order_print : {},
    index_charge: [],
    input_split_person: true,
  }),
  computed: {
    base_currency() {
      return store.getters["currency/base_currency"];
    },
    customers() {
      return store.getters["customer/customers"] || [];
    },
    loading_customer() {
      return store.getters["customer/loading"] || false;
    },
    meta_customers() {
      return store.getters["customer/meta"] || [];
    },
    restaurant() {
      return store.getters["restaurant/restaurant"];
    },
    data_split() {
      return store.getters["order/data_split"];
    },
  },

  mounted() {
    if(this.invoice.number_split > 0){
      this.tab =2
      this.total_person = this.invoice.number_split;
      let indexPaids = this.invoice.amount_paid / (this.invoice.amount_to_be_paid/ this.total_person) 
      for (let i = 0; i <= Number(indexPaids); i++) {
         this.index_charge.push(i) 
      }
      this.input_split_person = false

    } 
    this.invoice.sale_details.forEach((el) => {
      el.max_qty = el.qty;
      this.invoice_map.push(JSON.parse(JSON.stringify(el)));
    });  

  },

  methods: {
   async splitPerson(index){
     if(this.total_person && this.total_person > 1){
          this.index_charge.push( index) 
          this.order_print = this.invoice

          this.number_split = this.total_person          
          await store.dispatch('order_list/splitPerson',    
              {
                  "sale_id": this.invoice.id,
                  "number_split": this.total_person,
                  "cash_received": (this.invoice.amount_to_be_paid-this.invoice.amount_paid) / this.total_person
              }
          ) 
          this.order_print.number_split =  this.number_split
          this.input_split_person = false
          this.modal_invoice_preview = true
     }
   },
    
   async  openSale(isNewSplit){ 
      let data = this.data_split.old_sale
      if(isNewSplit){
        data= this.data_split.new_sale
      }
      this.modal_success = false
      return this.$emit("opened", {
        modal: false,
        change: false,
        invoice: data,
      });
    },
    async submit(){ 

      let data = {
        sale_id: this.invoice.id,
        customer_id: this.customer.id,
        split_sale_details:[]
      }
      this.selected.forEach(function(el){
        data.split_sale_details.push({
          sale_detail_id: el.id,
          qty: el.qty
        })
      });
      await store.dispatch('order/SplitSale',data);
      this.modal_success = true


    },
    customerSave(saved) {
      if (saved === true) {
        this.modal_customer = false;
        this.modal_create_customer = false;
      }
    },
    setCustomer(customer) {
      if (this.customer.id === customer.id) {
        this.customer = {
          id: 0,
          name: this.$t("none"),
        };
        return;
      }
      this.customer = customer;
    },
    async showCustomerDialog() {
      this.modal_customer = true;
      await this.getCustomer();
    },
    async getCustomer() {
      this.model_customer.type_id = this.restaurant.id;
      await store.dispatch("customer/fetch_all_customer", this.model_customer);
    },
    async Close() {
      return this.$emit("opened", {
        modal: false,
        change: false,
        invoice: this.invoice,
      });
    },
    isSelect(item) {
      let find = _.find(this.selected, function (el) {
        return el.id === item.id;
      });
      if (find) return true;
      return false;
    },
    selectedItem(item) {

      const item_ = JSON.parse(JSON.stringify(item));
      if(this.invoice_map.length <= 1 && ( item.max_qty - item_.qty) <  1){
        Swal.fire({
          confirmButtonText: this.$i18n.t("yes"),
          text: this.$i18n.t("Item Menu Can't move all!")  ,
        });
        return;
      } 

      if (item_.qty == item.max_qty) {
        let index = this.invoice_map.findIndex((el) => {
          return el.id === item_.id;
        });
        this.invoice_map.splice(index, 1);
      } else {
        item.max_qty = item_.max_qty - item.qty;
        item.qty = item.max_qty;
      }

      let index_select = this.selected.findIndex((el) => {
        return el.id === item.id;
      });
      if (index_select < 0) {
        this.selected.push(item_);
      } else {
        this.selected[index_select].qty += item_.qty;
        item_.qty = this.selected[index_select].qty;
      }

      // if (index < 0) return;
    },

    reverseSelectedItem(item) {
      const item_ = JSON.parse(JSON.stringify(item));
      let index = this.invoice_map.findIndex((el) => {
        return el.id === item_.id;
      });
      if (index > -1) {
        this.invoice_map[index].qty = this.invoice_map[index].qty + item_.qty;
      } else {
        this.invoice_map.push(item_);
      }

      let index_select = this.selected.findIndex((el) => {
        return el.id === item.id;
      });
      this.selected.splice(index_select, 1);
    },
  },
};
</script>